import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';

import { InfoIconCircle } from '@/assets/icons/info-circle';
import { ds } from '@/components/lib/design.system';
import { Banner } from '@/feature/betslip-sbk/components/Banner';
import { useSbkBetSlipStore } from '@/feature/betslip-sbk/hooks/use-sbk-betslip-store';
import { hasSoccerSelectionSelector } from '@/feature/betslip-sbk/utils/betslip-selectors';

export const SoccerSettlementBanner = () => {
    const { t } = useTranslation('betslip_sbk');
    const hasSoccerSelection = useSbkBetSlipStore(hasSoccerSelectionSelector);

    if (!hasSoccerSelection) {
        return null;
    }

    return (
        <Banner
            leftIcon={<InfoIconCircle color={ds.colorValue.icon.primary} />}
            message={t('soccer_settlement_disclaimer')}
            backgroundColor={ds.colorToken.background.neutral.subtler}
            textColor={ds.colorToken.text.primary}
            style={styles.banner}
            testID="soccerSettlementBanner"
        />
    );
};

const styles = StyleSheet.create({
    banner: {
        borderColor: ds.colorValue.border.subtle,
        borderWidth: 1,
        marginBottom: 16,
    },
});
